// extracted by mini-css-extract-plugin
export default {"main":"aCYXhzL2BPtnr08w7xgI","btn":"oTHLzWMZiT12ZTkCxwHB"};